import { Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

export default function TipAndInstructions({
  specialInstructions,
  setSpecialInstructions,
  tip,
  setTip,
  tipPercentage,
  setTipPercentage,
  tipsEnabled = true,
  presets = [15, 18, 20]
}) {
  return (
    <>
      {/* Special Instructions */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Clock className="h-5 w-5 text-primary" />
            Special Instructions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Textarea
            value={specialInstructions}
            onChange={(e) => setSpecialInstructions(e.target.value)}
            placeholder="Any special requests for your order?"
            maxLength={500}
            className="resize-none"
            data-testid="special-instructions"
          />
        </CardContent>
      </Card>

      {/* Tip */}
      {tipsEnabled && (
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Add a Tip</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-2 mb-4">
            {presets.map((pct) => (
              <Button
                key={pct}
                variant={tipPercentage === pct ? "default" : "outline"}
                size="sm"
                onClick={() => setTipPercentage(pct)}
                className="flex-1"
                data-testid={`tip-${pct}`}
              >
                {pct}%
              </Button>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <span className="text-muted-foreground">Custom:</span>
            <Input
              type="number"
              value={tip}
              onChange={(e) => {
                setTip(Math.max(0, parseFloat(e.target.value) || 0));
                setTipPercentage(0);
              }}
              className="w-24"
              step="0.01"
              min="0"
              data-testid="custom-tip"
            />
          </div>
        </CardContent>
      </Card>
      )}
    </>
  );
}
